import register from 'ShopUiBundle/modules/app/registry';
import './newsletter-form.scss';

// tslint:disable-next-line
register('newsletter-form', () => import(/* webpackMode: "lazy" */'./newsletter-form'));
